import React from 'react';

function LoginError({message, onTryAgain = () => {}}) {
  let err = message || 'An Error Occured while trying to login.';
  if (localStorage.getItem('no_permissions')) {
    err = 'You donot have any permissions for this application.';
  }
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    >
      <h4 style={{fontSize: '1.5rem'}}>{err}</h4>
      <br />
      <button
        onClick={onTryAgain}
        className="btn btn-secondary"
        style={{backgroundColor: 'rgb(202,204,216)'}}
      >
        Try again
      </button>
    </div>
  );
}

export default LoginError;
